import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import ChartComponent from './ChartComponent';

const DoughnutChartComponent = ({
  title,
  link,
  subtitle,
  slices,
  data,
  showLegend,
  ...props
}) => {
  const dataObj = {
    datasets: [{
      data: data,
      backgroundColor: slices.map(s => s.colour),
      label: title,
      borderWidth: new Array(data.length).fill(0)
    }],
    labels: slices.map(s => s.label)
  };

  const options = {
    legend: { display: showLegend },
    cutoutPercentage: 80
  };

  return (
    <div style={{ position: 'relative' }}>
      <div
        style={{
          position: 'absolute',
          top: 30,
          left: 30,
          right: 30,
          bottom: 30,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center'
        }}
      >
        <div>
          <strong>
            {
              link ?
                <Link to={link}>{title}</Link> :
                title
            }
          </strong>
          <br />
          <small>{subtitle}</small>
        </div>
      </div>
      <div>
        <ChartComponent
          type="doughnut"
          data={dataObj}
          options={options}
          {...props}
        />
      </div>
    </div>
  );
};

DoughnutChartComponent.propTypes = {
  title: PropTypes.any,
  link: PropTypes.any,
  subtitle: PropTypes.string,
  slices: PropTypes.arrayOf(PropTypes.shape({
    colour: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  data: PropTypes.arrayOf(PropTypes.number).isRequired,
  showLegend: PropTypes.bool
};

export default DoughnutChartComponent;


// WEBPACK FOOTER //
// src/Components/DoughnutChartComponent.jsx